import React from 'react';
import type { WAbsoluteThemeComponentAssetView } from '@zola/svc-web-api-ts-client';
import { mapAbsoluteAssetViewToStyledImg } from './mappers';

export const renderAbsoluteAssets = (
  a?: WAbsoluteThemeComponentAssetView[]
): (JSX.Element | null)[] | null => {
  if (a) {
    if (a.length > 0) {
      return a.map((abs: WAbsoluteThemeComponentAssetView, i: number) => {
        const { style, image_url } = abs || {};
        if (!image_url || !style?.responsive_size) return null;

        const Img = mapAbsoluteAssetViewToStyledImg(style?.responsive_size);
        return <Img src={image_url} alt={style?.alt_text} key={`asset-${i}`} />;
      });
    }
  }
  return null;
};
